import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Footer from '../../../components/Footer';
import CsvUpload from '../../../components/template/createTemplate/CsvUpload';
import HeaderStructure from '../../../components/template/createTemplate/HeaderStructure';
import CreateTemplate from '../../../components/template/createTemplate/CreateTemplate';
import ColumnMapping from '../../../components/template/createTemplate/ColumnMapping';


const Dashboard: React.FC = () => {

    const [step, setStep] = useState<number>( 1 );
    const [ csvUUID, setCsvUUID ] = useState<string | null>( null );

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="main-container">
                            <div className="main-container-inner">
                                {
                                    step === 1 ? <CsvUpload setStep={setStep} setCsvUUID={setCsvUUID} /> :
                                    step === 2 ? <HeaderStructure setStep={setStep} csvUUID={csvUUID} /> :
                                    step === 3 ? <CreateTemplate setStep={setStep} csvUUID={csvUUID} /> :
                                    <ColumnMapping csvUUID={csvUUID} />
                                }
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="container d-none">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="main-container">
                          <div className="main-container-inner">
                            <div className="main-card revrex-data-table-card">
                                <h1 className="text-center mb-4">Step 1: Upload Csv</h1>
                                <input type={"file"} accept=".csv"
                                    onChange={fileChange}
                                />
                                <div>
                                    <button className="revrex-primary-btn" onClick={gotoStep2}>Next</button>
                                </div>
                            </div>
                          </div>
                          <Footer />
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
}

export default Dashboard;